import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { ParticulierService } from "src/app/particulier/core/service/particulier.service";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { RetailItem } from "src/app/particulier/core/model/retail-item";
import { RetailItemService } from "src/app/particulier/core/service/retail-item.service";
import { AnalyseParticulier } from "src/app/particulier/core/model/analyse-particulier";
import { AnalyseParticulierService } from "src/app/particulier/core/service/analyse-particulier.service";
import { ReportViewerModalComponent } from "src/app/formulaire/modal/viewer/report-viewer-modal/report-viewer-modal.component";
import { ReportingParticulierService } from "src/app/reporting/core/service/reporting-particulier.service";
import { CorrespondreDossierModalComponent } from "src/app/formulaire/modal/correspondre-dossier-modal/correspondre-dossier-modal.component";
import { EditCreditModalComponent } from "src/app/particulier/formulaire/modal/edit-credit-modal/edit-credit-modal.component";
import { UpdateFinanceIndividualComponent } from "src/app/formulaire/modal/particulier/update-finance-individual/update-finance-individual.component";
import { UpdateEmploiIndividualComponent } from "src/app/formulaire/modal/particulier/update-emploi-individual/update-emploi-individual.component";
import { UpdatePieceIndividualComponent } from "src/app/formulaire/modal/particulier/update-piece-individual/update-piece-individual.component";
import { UpdateInfoIndividualComponent } from "src/app/formulaire/modal/particulier/update-info-individual/update-info-individual.component";
import { ConditionRetail } from "src/app/particulier/core/model/condition-retail";
import { ConditionRetailService } from "src/app/particulier/core/service/condition-retail.service";
import { FormAddConditionComponent } from "src/app/particulier/formulaire/modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "src/app/particulier/formulaire/modal/form-edit-condition/form-edit-condition.component";

@Component({
  selector: "app-dossier-info-detail-tab",
  templateUrl: "./dossier-info-detail-tab.component.html",
  styleUrls: ["./dossier-info-detail-tab.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class DossierInfoDetailTabComponent implements OnInit {
  MyPermissions: string[];

  private userPermission = {
    permissions: [],
  };

  @Input() requestId: any;
  dossier: Request;

  individual: Individual;
  facilites: RetailItem[];

  analyseParticulier: AnalyseParticulier;

  conditions: ConditionRetail[];
  conditionArray: Array<ConditionRetail[]> = [];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  reportBlob: any = null;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private userService: UserService,
    private _keycloakService: KeycloakService,
    private _particulierService: ParticulierService,
    private _individualService: IndividualService,
    private _requestService: RequestService,
    private _retailItemService: RetailItemService,
    private _analyseParticulierService: AnalyseParticulierService,
    private _reportingParticulierService: ReportingParticulierService,
    private _conditionService: ConditionRetailService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.findCustomerByRequest(this.requestId);
    this.getListRetailItemByRequest(this.requestId);
    this.getAnalyseParticulierByrequestId(this.requestId);
    this.exportDossierParticulier(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findCustomerByRequest(requestId) {
    this._individualService.getIndividualByRequestId(requestId).subscribe(
      (data) => {
        this.individual = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListRetailItemByRequest(requestId) {
    this._retailItemService.getListRetailItemByRequest(requestId).subscribe(
      (data) => {
        this.facilites = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAnalyseParticulierByrequestId(requestId) {
    this._analyseParticulierService
      .getAnalyseParticulierByrequestId(requestId)
      .subscribe(
        (data) => {
          this.analyseParticulier = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  Apercu() {
    if (this.reportBlob != null) {
      const modalRef = this.modalService.open(ReportViewerModalComponent, {
        size: "lg",
        backdrop: "static",
        centered: true,
      });

      modalRef.componentInstance.destination = this.reportBlob;

      modalRef.result.then(
        (data) => {},
        (reason) => {}
      );
    }
  }

  exportDossierParticulier(requestId: string) {
    this._reportingParticulierService
      .exportDossierParticulier(requestId)
      .subscribe((blob) => {
        this.reportBlob = blob;
      });
  }

  telecharger() {
    this._reportingParticulierService
      .exportDossierParticulier(this.requestId)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", this.dossier.number + ".pdf");
        document.body.appendChild(link);
        link.click();
      });
  }

  updateRequest(requestId) {
    const modalRef = this.modalService.open(CorrespondreDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRequestById(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateCredit(retailItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.retailItemId = retailItemId;
    modalRef.componentInstance.workflowCode = this.dossier.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateFinance(individualId) {
    const modalRef = this.modalService.open(UpdateFinanceIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateEmploi(individualId) {
    const modalRef = this.modalService.open(UpdateEmploiIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updatePiece(individualId) {
    const modalRef = this.modalService.open(UpdatePieceIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateInfo(individualId) {
    const modalRef = this.modalService.open(UpdateInfoIndividualComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.individualId = individualId;

    modalRef.result.then(
      (data) => {
        // on close

        this.getRequestById(this.requestId);
        this.findCustomerByRequest(this.requestId);
        this.getListRetailItemByRequest(this.requestId);
        this.getAnalyseParticulierByrequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionRetailsByRetailItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.retailItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteConditionRetail(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  
  renouvelle(): void {
    this._router.navigate([this.dossier.workflow.createForm + "/" + this.dossier.workflow.code + "/" + this.dossier.id]);
  }


}
